export default "__VITE_ASSET__CbFP8DED__"